import { callApi } from "../../utils/common.utils";
import axios from 'axios';
import { UPFLOW_URL } from "../../constants/app.constants";

// export const fetchBenchmarkInvoicingList = async (userId: string | null) => {
//   const payLoad = {
//     id: userId,
//   };
//   return callApi("getInvoicing", payLoad, "getData");
// };

// export const fetchBenchmarkInvoicingList = async () => {
//     try {
//     const quickbookId = localStorage.getItem("Intake_QuickbooksAccount"); 

//     const response = await axios.post(
//    `${UPFLOW_URL}/api/controller/upflowIntegration.php`,
//     { quickbookId },
//     {
//     headers: {
//       "Content-Type": "application/json",
//     },
//   }
// );
//     return response.data;
//     } catch (error) {
//     console.error("Error fetching invoicing data:", error);
//     throw error;
//   }
// };

export const fetchBenchmarkInvoicingList = async () => {
  try {
    const quickbookId = localStorage.getItem("Intake_QuickbooksAccount");

    if (!quickbookId) {
      console.error("Quickbook ID not found in localStorage.");
      return [];
    }

    const response = await axios.post(
      `${UPFLOW_URL}/api/controller/upflowIntegration.php`,
      { quickbookId },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching invoicing data:", error);
    throw error;
  }
};



export const printBenchmarkInvoice = async (
  userId: string | null,
  invoiceId: number
) => {
  const payLoad = {
    id: userId,
    invoiceId: invoiceId,
  };
  return callApi("printInvoice", payLoad, "getData");
};
